import React from 'react';

const SvgActions110 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10.53 4a.5.5 0 0 0-.53.51v5.52l3.84 3.85a.5.5 0 0 0 .73 0 6 6 0 0 0-4-9.86zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-18C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions110 svgRef={ref} {...props} />);
export default ForwardRef;
